import { Button } from '@monorepo/shared/componentsV2/Button';
import { ButtonsGroup } from '@monorepo/shared/componentsV2/ButtonsGroup';
import { Header } from '@monorepo/shared/componentsV2/Header';
import { Search } from '@monorepo/shared/componentsV2/Search';
import React, { useCallback } from 'react';
import styled from 'styled-components';

const SearchContainer = styled.div`
  max-width: 10rem;
`;

const ButtonContainer = styled.div`
  min-width: 7rem;
`;

interface FoldersHeaderProps {
  filter: string;
  onSearch: (search: string) => void;
  onCreate: () => void;
  canCreateFolder: boolean;
}

export function FoldersHeader({
  filter,
  onSearch,
  onCreate,
  canCreateFolder,
}: FoldersHeaderProps) {
  const handleSearch = useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => onSearch(e.target.value),
    [onSearch],
  );

  return (
    <Header
      title="Documents"
      variant="noDropShadow"
      rightActions={
        <ButtonsGroup>
          <SearchContainer>
            <Search onChange={handleSearch} value={filter} />
          </SearchContainer>
          {canCreateFolder && (
            <ButtonContainer>
              <Button color="primary" variant="contained" onClick={onCreate}>
                Create folder
              </Button>
            </ButtonContainer>
          )}
        </ButtonsGroup>
      }
    />
  );
}
